// WEBSCKETS

// channels
export const CHANNEL_START_ROUTE_NAME = 'route';
export const CHANNEL_ATRIL_PANTALLA_NAME = 'canal-atril-pantalla';
export const CHANNGEL_PANTALLA_ATRIL_NAME = 'canal-pantalla-atril';
export const CHANNEL_ATRIL_CHATBOT_MESSAGE = 'atril-chatbot-messages';


// events
export const START_ROUTE_EVENT = 'display';
export const SHOW_HOME_PAGE_EVENT = 'show-home-page';
export const CHANGE_DAY_ROUTE_EVENT = 'change-route-day';
export const GO_TO_NORMAL_OR_SATURED_DETAIL_PAGE_EVENT = 'go-to-normal-or-satured-detail-page';
export const GO_TO_IMMERSIVE_DETAIL_PAGE_EVENT = 'go-to-immersive-detail-page';
export const GO_TO_HOME_PAGE_EVENT = 'go-to-home-page';
export const START_IMMERSIVE_MODE_EVENT = 'start-immersive-mode';
export const USER_MESSAGE = 'user-message';
export const BOT_MESSAGE = 'bot-message';

export const CHANNEL_DEV_ACTIONS = 'dev-actions'
export const RESTART = 'restart';
export const START_TOKEN = 'start-token';
export const SHOW_SAY_GOOD_BYE_VIEW_EVENT = 'show-say-good-bye-view';
export const END_EXPERIENCE_EVENT = 'end-experience';

